import React, { Component } from 'react';
import { View, Image, Text, TouchableOpacity, Platform } from 'react-native';
import styles from '../styles/styles';
import chatstyles from '../styles/chatStyles';
import { LinearGradient } from 'expo-linear-gradient';
import { BoldText } from './BoldText';
import { ChatButtons } from './ChatButtons';
import ChatCheckBox from './ChatCheckBox';
import CustomRating from './CustomRating';
import customerImage from '../../assets/images/customer.png';
import botavatarImage from '../../assets/images/botavatar.png';
import wnslogo from '../../assets/images/icon.png';
class ChatBox extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  //replace hyperlinks in messages
  checkForLinks = (textValue) => {
    if (this.props.botMessage.link && this.props.botMessage.link.type) {
      const tempValues = textValue.split(this.props.botMessage.link.linkFor);

      switch (this.props.botMessage.link.type) {
        case 'restart':
          return (
            <>
              {Platform.OS === 'ios' ? (
                <View>
                  <Text style={{ marginTop: 15, marginLeft: 15 }}>
                    <Text
                      style={{
                        fontSize: 15,
                        fontWeight: '300',
                        color: '#273a4e',
                        fontStyle: 'normal',
                        lineHeight: 22,
                        padding: 10,
                        fontFamily: 'SFProText',
                        textAlignVertical: 'center',
                      }}
                    >
                      {tempValues[0]}
                    </Text>

                    <TouchableOpacity onPress={() => this.props.initiateChat()}>
                      <Image
                        style={[styles.reloadImageOrange]}
                        source={require('../../assets/images/reload-orange.png')}
                      ></Image>
                    </TouchableOpacity>

                    <Text
                      style={{
                        fontSize: 15,
                        fontWeight: '300',
                        color: '#273a4e',
                        fontStyle: 'normal',
                        lineHeight: 22,
                        padding: 10,
                        fontFamily: 'SFProText',
                        textAlignVertical: 'center',
                      }}
                    >
                      {tempValues[1]}
                    </Text>
                  </Text>
                </View>
              ) : (
                <>
                  {tempValues[0]}
                  <TouchableOpacity onPress={() => this.props.initiateChat()}>
                    <Image
                      style={styles.reloadImageOrange}
                      source={require('../../assets/images/reload-orange.png')}
                    ></Image>
                  </TouchableOpacity>
                  {tempValues[1]}
                </>
              )}
            </>
          );

        case 'uprn_resubmit':
          return (
            <>
              {tempValues[0]}
              <Text
                style={chatstyles.chatLink}
                onPress={() => this.props.updateSentMessage('Need changes')}
              >
                {this.props.botMessage.link.linkFor}
              </Text>
              {tempValues[1]}
            </>
          );

        case 'terms':
          return (
            <>
              {Platform.OS === 'ios' ? (
                <View>
                  <Text style={{ marginTop: 15, marginLeft: 15 }}>
                    <Text
                      style={{
                        fontSize: 15,
                        fontWeight: '300',
                        color: '#273a4e',
                        fontStyle: 'normal',
                        lineHeight: 22,
                        padding: 10,
                        fontFamily: 'SFProText',
                        textAlignVertical: 'center',
                      }}
                    >
                      {tempValues[0]}
                    </Text>

                    <TouchableOpacity onPress={() => this.props.showTerms()}>
                      <Text
                        style={[chatstyles.chatLink, chatstyles.underline]}
                      //onPress={() => this.props.showTerms()}
                      >
                        {this.props.botMessage.link.linkFor}
                      </Text>
                    </TouchableOpacity>

                    <Text
                      style={{
                        fontSize: 15,
                        fontWeight: '300',
                        color: '#273a4e',
                        fontStyle: 'normal',
                        lineHeight: 22,
                        padding: 10,
                        fontFamily: 'SFProText',
                        textAlignVertical: 'center',
                      }}
                    >
                      {tempValues[1]}
                    </Text>
                  </Text>
                </View>
              ) : (
                <>
                  {tempValues[0]}
                  <TouchableOpacity onPress={() => this.props.showTerms()}>
                    <Text
                      style={[chatstyles.chatLink, chatstyles.underline]}
                    //onPress={() => this.props.showTerms()}
                    >
                      {this.props.botMessage.link.linkFor}
                    </Text>
                  </TouchableOpacity>
                  {tempValues[1]}
                </>
              )}
            </>
          );

        default:
          return textValue;
      }
    } else {
      return textValue;
    }
  };

  // replace bold tags
  replaceBoldTags = (fullString) => {
    fullString = fullString.toString();
    const htmlTags = fullString.match(/<B>.*?<\/B>/g);
    if (!htmlTags) {
      return this.checkForLinks(fullString);
    }
    let firstTag = htmlTags[0];
    const myStr = firstTag.replace(/<[/]?(b)>/gi, '');
    const tempArr = fullString.split(firstTag);
    return (
      <>
        {tempArr.map((each, index) => (
          <React.Fragment nativeID={`textKey${index}`}
            key={`textKey${index}`}>
            {this.replaceBoldTags(each)}
            {index < tempArr.length - 1 && (
              <BoldText key={index}>{myStr}</BoldText>
            )}
          </React.Fragment>
        ))}
      </>
    );
  };

  //render ui
  render() {
    const { botMessage, loginType, isAgentTyping } = this.props;
    const isRight = botMessage && botMessage.from === loginType;
    let rightImage = customerImage;
    let leftImage =
      this.props.isAgentConnected &&
        this.props.botMessage.interactionType === 'live_agent'
        ? wnslogo
        : botavatarImage;
    if (loginType === 'bot') {
      rightImage =
        this.props.botMessage.interactionType === 'live_agent'
          ? wnslogo
          : botavatarImage;
      leftImage = customerImage;
    }
    return (
      <>
        <View style={isRight ? styles.chatbubbleright : styles.chatOuterView}>
          <View>
            {isRight ? (
              <Image style={styles.customeravatar} source={rightImage}></Image>
            ) : (
              <>
                {this.props.isAgentConnected &&
                  botMessage.interactionType === 'live_agent' && (
                    <Image
                      style={styles.onlineImage}
                      source={require('../../assets/images/online.png')}
                    ></Image>
                  )}
                <Image
                  style={styles.chatmessageavatar}
                  source={leftImage}
                ></Image>
              </>
            )}
            {!isAgentTyping && (
              <Text style={styles.chatTime}>
                {new Date(botMessage.sentAt).toLocaleString([], {
                  hour12: false,
                  hour: '2-digit',
                  minute: '2-digit',
                })}
              </Text>
            )}
          </View>
          {/* below view is for triangle corner of chat messages */}
          <View
            style={[
              isRight ? chatstyles.chatrightcorner : chatstyles.chatleftcorner,
              !isAgentTyping ? styles.marginBottom20 : null,
            ]}
          ></View>
          {isAgentTyping ? (
            <View style={styles.agentonTypingView}>
              <Image
                style={styles.typingImage}
                source={require('../../assets/images/typing.gif')}
              ></Image>
            </View>
          ) : isRight ? (
            <LinearGradient
              colors={['#f19058', '#d15a5e']}
              style={[
                styles.chatbubblerighttext,
                styles.maxWdth80Percent,
                styles.marginBottom20,
              ]}
              start={[0.0, 0.5]}
              end={[1.0, 0.5]}
            >
              <Text
                nativeID={`message${this.props.idValue}`}
                style={[styles.chatbubblerighttext, styles.padding10]}>
                {this.replaceBoldTags(botMessage.message)}
              </Text>
            </LinearGradient>
          ) : (
            <View style={chatstyles.msgContainer}>
              <Text nativeID={`message${this.props.idValue}`}
                style={styles.chatbubblelefttext}>
                {this.replaceBoldTags(botMessage.message)}
              </Text>
              {botMessage.buttons && botMessage.buttons.length > 0 && (
                <ChatButtons
                  disableOptions={this.props.disableOptions}
                  buttons={botMessage.buttons}
                  updateSentMessage={this.props.updateSentMessage}
                />
              )}
              {botMessage.checkbox && botMessage.checkbox.length > 0 && (
                <ChatCheckBox
                  disableOptions={this.props.disableOptions}
                  checkbox={botMessage.checkbox}
                  updateSentMessage={this.props.updateSentMessage}
                />
              )}
              {this.props.ratingsFlag && (
                <CustomRating
                  disableOptions={this.props.disableOptions}
                  updateSentMessage={this.props.updateSentMessage}
                />
              )}
            </View>
          )}
        </View>
      </>
    );
  }
}
export default ChatBox;
